import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BlockUIModule } from 'ng-block-ui';
import { FormsModule } from '@angular/forms';
import { BlockUIHttpModule } from 'ng-block-ui/http';
import { ModaleAvvisoComponent } from './_modal/modale-avviso/modale-avviso.component';
import { ModaleConfermaComponent } from './_modal/modale-conferma/modale-conferma.component';
import { ModaleInputComponent } from './_modal/modale-input/modale-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { ModaleInputMultiploComponent } from './_modal/input-multiplo-modal/input-multiplo-modal.component';
import { HasPermissionDirective } from './_directive/has-permission.directive';
import { InputMetadatoComponent } from './_components/input-metadato/input-metadato.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SezionaPipe } from './_pipes/seziona.pipe';
import { ModaleErroreComponent } from './_modal/modale-errore/modale-errore.component';
import { ToastContainerComponent } from './_components/toast-container/toast-container.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModaleCambioPasswordComponent } from './_modal/modale-cambio-password/modale-cambio-password.component';
import { AutofocusDirective } from './_directive/autofocus.directive';
import { NgbTooltipKeDocDirective } from './_directive/ngb-tooltip.directive';
import { SpinnerTemplateComponent } from './_components/spinner-template.component';

@NgModule({
	declarations: [
		ModaleAvvisoComponent,
		ModaleConfermaComponent,
		ModaleInputComponent,
		ModaleInputMultiploComponent,
		ModaleErroreComponent,
		HasPermissionDirective,
		AutofocusDirective,
		InputMetadatoComponent,
		SezionaPipe,
		ToastContainerComponent,
		ModaleCambioPasswordComponent,
		NgbTooltipKeDocDirective,
	],
	imports: [
		CommonModule,
		NgSelectModule,
		FormsModule,
		NgbModule,
		TranslateModule.forChild(),
		BlockUIModule.forRoot({
			template: SpinnerTemplateComponent,
			delayStart: 400,
			delayStop: 500,
		}),
		BlockUIHttpModule.forRoot({
			requestFilters: [
				{ method: 'GET', url: /\/domini/ },
				{ method: 'GET', url: /(\?|&)skip=/ },
				{ method: 'POST', url: /(\?|&)skip=/ },
				{ method: 'PUT', url: /(\?|&)skip=/ },
			],
		}),
		NgxDropzoneModule,
	],
	exports: [
		CommonModule,
		NgSelectModule,
		FormsModule,
		NgbModule,
		TranslateModule,
		BlockUIModule,
		HasPermissionDirective,
		AutofocusDirective,
		InputMetadatoComponent,
		NgxDropzoneModule,
		SezionaPipe,
		ToastContainerComponent,
		NgbTooltipKeDocDirective,
	],
})
export class SharedModule {}
